export enum DutyBranch {
  Live = 'live',
  Review = 'review',
  Edit = 'edit',
}
